import { Client, Controller } from "..";
import { AgentPermissionsState } from "@/common/stores/persistingStores/agentPermissions";

export const fetchAgentPermissions = (): Promise<AgentPermissionsState> => {
	return Client.instance.get(Controller.AgentPermissions);
};
